import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { httpStatusEnum } from 'appconstants';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';

export const OPEN_SETUP_ACTIONS = {
  GET_OPENSETUP: '@protocol/opensetup/getopensetup',
  SET_REG_STEP_INDEX: '@protocol/opensetup/setRegStepIndex',
  GET_RELATIONS: '@protocol/opensetup/relations',
  GET_EMBEDDED: '@protocol/opensetup/embedded'
};

export const setRegStepIndex = regStepIndex => dispatch => {
  const action = {
    type: OPEN_SETUP_ACTIONS.SET_REG_STEP_INDEX,
    payload: regStepIndex
  };
  dispatch(action);
};

export const getOpenSetup = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: OPEN_SETUP_ACTIONS.GET_OPENSETUP + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/opensetup`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: OPEN_SETUP_ACTIONS.GET_OPENSETUP + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: OPEN_SETUP_ACTIONS.GET_OPENSETUP + suffixRejected,
          payload: error
        });
      }
    );
};

export const setOpenSetupConfig = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/opensetup`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getOpenSetup(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );


export const setOpenSetupCourierNotes = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/couriernote`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  )
  .pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getOpenSetup(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const saveRegistrationSteps = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/step`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getOpenSetup(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const saveOpenPersonTypes = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/openpersontype`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getOpenSetup(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const saveIRTFProviderSetup = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/rtfs`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(getOpenSetup(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        ));
      }
      return resp;
    })
  );


export const getRelations = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: OPEN_SETUP_ACTIONS.GET_RELATIONS + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/relations`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: OPEN_SETUP_ACTIONS.GET_RELATIONS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: OPEN_SETUP_ACTIONS.GET_RELATIONS + suffixRejected,
          payload: error
        });
      }
    );
};

export const saveRelations = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/relations`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getRelations(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const saveEmbedded = (token, loggerInfo, postBody, id) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/embedded`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getRelations(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

  export const saveEmbeddedNP = (token, loggerInfo, postBody, id) => (
    dispatch,
    getState
  ) => http
    .putWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/id/${id}/embeddednpstudy`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    ).pipe(
      map(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          dispatch(
            getRelations(
              token,
              loggerInfo,
              getState().prtDetails.prtInfo.protocolNumber
            )
          );
        }
        return resp;
      })
    );
